export default __webpack_public_path__ + "static/media/Mickey-thompson.6719b5d2.png";